import { createAction } from 'redux-actions';

export const createChatAction = (conversationID, type) =>
  createAction(`chats/${conversationID}/${type}`);

export const setCharCounter = createAction('chats/SET_CHAR_COUNTER');

export const setFiltersOrder = createAction('conversations/SET_FILTERS_ORDER');

export const setFilterOnlyUnread = createAction(
  'conversations/SET_FILTER_ONLY_UNREAD'
);

export const setFiltersOpen = createAction('conversations/SET_FILTER_OPEN');

export const resetFilters = createAction('conversations/RESET_FILTERS');

export const setSelectedConversation = createAction(
  'conversations/SET_SELECTED_CONVERSATION'
);

export const setMessagesSearch = createAction('chats/SET_MESSAGES_SEARCH');

export const setScrollToBottom = createAction('chats/SET_SCROLL_TO_BOTTOM');

export const setConversations = createAction('conversations/SET_CONVERSATIONS');

export const addConversations = createAction('conversations/ADD_CONVERSATIONS');

export const updateConversation = createAction(
  'conversations/UPDATE_CONVERSATION'
);

export const addChannelTypesToConversations = createAction(
  'conversations/ADD_CHANNEL_TYPE_TO_CONVERSATIONS'
);
